import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { Interceptor } from './core/interceptors/interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { provideToastr } from 'ngx-toastr';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { DialogService } from './shared/services/dialog.service';
import { NgSelectConfig } from '@ng-select/ng-select';
import { dashboardWidgetContextInterceptor } from './core/interceptors/dashboard-widget-context.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({
      eventCoalescing: true,
      runCoalescing: true
    }),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(
      withInterceptors([Interceptor, errorInterceptor,dashboardWidgetContextInterceptor])
    ),
    provideAnimations(),
    provideToastr({
      timeOut: 5000,
      positionClass: 'toast-bottom-full-width',
      preventDuplicates: true,
      progressBar: true
    }),
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        autoFocus: false,
        disableClose: true,
        maxWidth: '90vw',
        maxHeight: '90vh'
      }
    },
    {
      provide: NgSelectConfig,
      useFactory: () => {
        const config = new NgSelectConfig();
        config.clearSearchOnAdd = true;
        return config;
      }
    },
    DialogService
  ]
};
